<template>
  <div>
    <stock :searchObj="searchObj" :stockTypeObj="stockTypeObj" ref="stock" @postListData="postListData">
      <template v-slot:searchDiv>
        <div class="secondSearchLine">
          <el-date-picker v-model="searchObj.date" value-format="yyyy-MM-dd" style="width:1.5rem" size="mini" type="date" placeholder="选择日期"></el-date-picker>
          <div class="areaDiv">
            <span>面积大于：</span>
            <el-input size="mini"></el-input>
          </div>
          <div class="areaDiv">
            <span>面积小于：</span>
            <el-input size="mini"></el-input>
          </div>
        </div>
      </template>
      <template v-slot:contentDiv>
        <div v-for="(item,index) in dataList" :key="index">
          <div v-if="item.productType==2">
            <exclusive-stock :keyStr="keyStr" :productObj="item"></exclusive-stock>
          </div>
          <div v-else class="contentDiv">
            <hotel-resource-left :productObj="item" :showTag="false" :rightShowStyle="2" :btnName="'向会场询价'" class="contentHead"></hotel-resource-left>
            <div class="contentContainer" v-if="item.isOpen">
              <div class="boxContainer1">   
                <div v-for="(item2,index2) in item.stockListResults" :key="index2">
                  <div class="firstLine">
                    <span class="productName">{{item2.productNameCn}}</span>
                    <span>{{item2.productDesc}}</span>
                    <i class="el-icon-circle-plus-outline" @click="addBudget(item,item2)"></i>
                  </div>
                </div>
              </div>
              <p style="text-align: right">
                <i class="el-icon-caret-top" @click.stop="item.isOpen = false"></i>
              </p>
            </div>
          </div>
        </div>
      </template>
    </stock>
    <create-product-dialog ref="createProduct" :keyStr="keyStr"></create-product-dialog>
  </div>
</template>

<script>
import Stock from './stock.vue'
import Api from '@/components/Api/index.js'
import hotelResourceLeft from './child/hotelResourceLeft.vue'
import CreateProductDialog from './addProductDialog/createProductDialog.vue'
export default {
  components:{Stock,hotelResourceLeft, CreateProductDialog},
  props:{
    stockTypeObj:{
      type:Object,
      default:()=>{return {}}
    },
    checkState:{
      type:Number,
      default:0,
    }
  },
  data(){
    return{
      searchObj:{
        cityId:null,
        cityName:null,
        cityNameCn:null,
        cityNameEn:null,
        countryId:null,
        date:'',
        star:null,
        location:null,
        searchHotelPrice:null,
        keyword:null,
        productType:0,
        state:1,
      },
      dataList:[],
      keyStr:'',
    }
  },
  methods:{
    postListData(type){
      if(this.checkState===1){
        if(type=='empty'){
          this.dataList =[]
          this.keyStr=''
        }
        this.searchObj.startDate = this.searchObj.date;
        this.searchObj.endDate = this.searchObj.date;
        this.searchObj.key = this.keyStr;
        if(!this.$refs.stock.isMore){
          new Api('resource').rightStockList({page:this.$refs.stock.page,size:10,q:this.searchObj}).then(res => {
            if (res.status == 200) {
              if(res.data.length<10) this.$refs.stock.isMore = true;
              this.$refs.stock.getDateList(res.data)
              res.data.forEach(element => {
                this.dataList.push(element)
              });
              this.keyStr = res.key
            }else{
              this.$message({type:"error",message:res.statusText})
            }
          })
        }
      } 
    },
    addBudget(item,item1){
      this.$refs.createProduct.beforeOpen(item,item1,this.$refs.stock.budget)
    }
  }
}
</script>

<style lang="scss" scoped>
.secondSearchLine{
  display: flex;
  align-items: center;
  .areaDiv{
    margin-left: 0.1rem;
    display: flex;
    align-items: center;
    >div{
      width: 1rem;
    }
  }
}
.contentDiv{
  border-radius: 12px 12px 0 0;
  border: 1px solid #db4e1a;
  padding-top: 0.1rem;
  margin-bottom: 0.07rem;
  .contentHead{
    display: flex;
    justify-content: space-between;
    border-bottom: 3px solid #db4e1a;
    .head_left{    
      /deep/ .showCard-imgBox{
        margin-left: 0;
        img{
          margin: 0 0.05rem;
        }
      }
    }
  }
  .contentContainer{
    .boxContainer1{
      font-size: 0.12rem;
      margin-top: 0.1rem;
      margin-left: 0.1rem;    
      .firstLine{
        font-weight: bold;
        display: flex;
        align-items: center;
        i{
          font-size: 0.3rem;
          margin-left: 1.5rem;
        }
      }
      .productName{
        font-size: 0.125rem;
        width: 1.4rem;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    >p{
      >i{
        font-size: 0.25rem;
      }
    } 
  }
}
</style>